import Vue from 'vue'

const state = {
  token: ''
}
const getters = {
  token: state => state.token
}

const mutations = {
  TOKEN (state, list) {
    state.token = list
  }
}
const actions = {
  TOKEN_DPH ({ commit }) {
    Vue.http({
      method: `POST`,
      url: Vue.conf.Api.token,
      data: {
        grant_type:'password',
        client_type: 'pc'
      },
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }]
    }).then(function (res) {
        commit('TOKEN', res.data.access_token)
        Vue.storage.setLs( 'token', res.data.access_token)
    })
  },
  SET_TOKEN  ({ commit }, token) {
    commit('TOKEN', token)
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
